var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.5938C30 6.56641 23.4961 0.0625 15.4688 0.0625C7.44141 0.0625 0.9375 6.56641 0.9375 14.5938C0.9375 21.8594 6.21094 27.8945 13.1836 28.9492V18.8125H9.49219V14.5938H13.1836V11.4297C13.1836 7.79688 15.3516 5.74609 18.6328 5.74609C20.2734 5.74609 21.9141 6.03906 21.9141 6.03906V9.61328H20.0977C18.2812 9.61328 17.6953 10.7266 17.6953 11.8984V14.5938H21.7383L21.0938 18.8125H17.6953V28.9492C24.668 27.8945 30 21.8594 30 14.5938Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFacebookLogo);
export default __webpack_public_path__ + "static/media/black-facebook-logo.12bdc54dc8655f8052743ac466f3a544.svg";
export { ForwardRef as ReactComponent };